$(window).scroll(function() { 
  if ($(window).scrollTop() > 800 ) {
      // $('.needsclick').addClass('activeKlaviyo');
   }
});

$(document).ready(function () {

  let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
  console.log(items)
  items.forEach(item => {
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
      item.querySelector("ul").addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  });
  
  });

  
  var combinedHTML = "";
   $(".image_banner_custom").each(function () {
      combinedHTML += $(this).html();
  });

 $(".customSlider").html(combinedHTML);  
 $(".customSlider").slick({
    infinite: false,
    autoplay: false, 
    slidesToScroll: 1,
    slidesToShow: 1,
    adaptiveHeight: true, 
    prevArrow:
      '<button type="button" class="slick-prev slick-arrow"><svg class="Icons" role="presentation" viewBox="0 0 6 9"><path d="M5 8.5l-4-4 4-4" stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square"></path></svg></button>',
    nextArrow:
      '<button type="button" class="slick-next slick-arrow"><svg class="Icons" role="presentation" viewBox="0 0 6 9"><path d="M1 8.5l4-4-4-4" stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square"></path></svg></button>',
 });


  
   if ($(".scrollmenu.desktop_hidden .h_menu").hasClass("active")) { 
       $('.quizactive').css('background-color', '#f7f7f7');
    }else{
      $('.quizactive').css('background-color', '#73cbb6');
    }

  
     $('.best_seller_slider').slick({
    dots: false,
    arrows: true,
    infinite: false,
    slidesToShow: 5,
    slidesToScroll: 1,
      prevArrow:'<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><svg width="15" height="28" viewBox="0 0 15 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.75 26.5L1.25 14L13.75 1.5" stroke="#212121" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      nextArrow:'<button class="slick-next slick-arrow" aria-label="Next" type="button"><svg width="15" height="28" viewBox="0 0 15 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.25 26.5L13.75 14L1.25 1.5" stroke="#212121" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
     responsive: [
      {
        breakpoint: 1900,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 641,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
          arrows: true,
          adaptiveHeight: true,
        }
      }     
      
    ]
  });
  $(".footer-block__heading").click(function () {
    $(this).toggleClass("active"), $(this).next().toggle();
  }),
    $("h2.accordian_menu.header__menu-item.submenu__heading").click(
      function () {
        $(this).toggleClass("active"), $(this).next().toggle();
      }
    ),
    // $(".header__inline-menu details")
    //   .mouseover(function () {
    //     $(this).attr("open", !0);
    //   })
    //   .mouseout(function () {
    //     $(this).removeAttr("open");
    //   }),
    $("a.h_menu").click(function () {
      $(this).addClass("active").siblings().removeClass("active");
    }),
    $("a.ingrediant_info_link").click(function () {
      $(".bg_overlay,.infrediant_popup").fadeIn();
    }),
    $(".infrediant_info span.close_icon,.bg_overlay.active").click(function () {
      $(".bg_overlay,.infrediant_popup").fadeOut();
    }),
    (i = $(".product-form__input input[type=radio]:checked+label span").text()),
    $("fieldset.product-form__input.option_color legend.form__label span").text(
      ": " + i
    ),
    $(".color_label").click(function () {
      var e = $(this).find("span").text();
      $(
        "fieldset.product-form__input.option_color legend.form__label span"
      ).text(": " + e);
    });
  for (
    var e = $(".announcement-bar__message").text().split(" "), t = 0;
    t < e.length;
    t++
  )
    if (36 == e[t].charCodeAt(0)) {
      var n = t;
      break;
    }
  var i,
    o = e[n].replace("$", ""),
    a = parseInt(window.Shopify.currency.rate);
  console.log(a);
  var c = parseInt(a * o),
    r = document.querySelector("html").getAttribute("data-currency");
  e[n] = r + c;
  let l = e.join(" ");
  $(".announcement-bar__message").text(l);
}),
  $(document).on("click", "a.dah_link", function () {
    $(".dah_section #dropahint_wrapper").trigger(click);
  }),
  $(window).resize(function () {
    749 > $(window).width() &&
      $(".footer-block__heading").click(function () {
        $(this).toggleClass("active"), $(this).next().toggle();
      });
  });
var width = $(window).width();
width < 749 &&
  $(".article__sidebar").insertBefore(".article-template__comment-wrapper"),
  $("#shopify-section-infinite-text").appendTo(".scrolling_content");

/*
$(window).scroll(function() {
   console.log('scrolling ', $(window).scrollTop());
  if ($(window).scrollTop() > 800 ) {
      $('.needsclick.kl-private-reset-css-Xuajs1').parent('div').addClass('activeSwym');
   }
});


const script = document.createElement('script');
script.type = 'text/javascript';
script.async = true;
// specifically this line below makes PageView get's properly triggered and fired
script.onload = () => { dataLayer.push({ event: 'gtm.js', 'gtm.start': (new Date()).getTime(), 'gtm.uniqueEventId': 0 }); }
script.src = 'https://www.googletagmanager.com/gtm.js?id=GTM-WDPWR3D'

document.head.appendChild(script);
*/

    document.addEventListener("DOMContentLoaded", function() {
  var lazyloadImages = document.querySelectorAll("img.lazy");    
  var lazyloadThrottleTimeout;
  
  function lazyload () {
    if(lazyloadThrottleTimeout) {
      clearTimeout(lazyloadThrottleTimeout);
    }    
    
    lazyloadThrottleTimeout = setTimeout(function() {
        var scrollTop = window.pageYOffset;
        lazyloadImages.forEach(function(img) {
            if(img.offsetTop < (window.innerHeight + scrollTop)) {
              img.src = img.dataset.src;
              img.classList.remove('lazy');
            }
        });
        if(lazyloadImages.length == 0) { 
          document.removeEventListener("scroll", lazyload);
          window.removeEventListener("resize", lazyload);
          window.removeEventListener("orientationChange", lazyload);
        }
    }, 20);
  }
  
  document.addEventListener("scroll", lazyload);
  window.addEventListener("resize", lazyload);
  window.addEventListener("orientationChange", lazyload);
});
$(document).ready(function () {
   var getautoplay = $(document).find('.banner_img_sections').attr('data-autoplay');
   var getautoplaySpeed = $(document).find('.banner_img_sections').attr('data-autoplayspeed'); 
  $(".new_banner").slick({
    infinite: false,
    autoplay: getautoplay,
    autoplaySpeed: getautoplaySpeed,
    slidesToScroll: 1,
    slidesToShow: 1,
    adaptiveHeight: true,  
    dots: true,
    arrows: false,
 });
}); 

$(document).ready(function (){
  $(".cdd-cstm-home-logo").slick({
    infinite: true,
    adaptiveHeight: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
  	autoplaySpeed: 5000,
    dots: false,
    prevArrow:'<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="20" cy="20" r="20" fill="white"/><path d="M27 20H13" stroke="black" stroke-linecap="round" stroke-linejoin="round"/><path d="M20 27L13 20L20 13" stroke="black" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    nextArrow:'<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="20" cy="20" r="19.5" fill="white" stroke="white"/><path d="M13 20H27" stroke="black" stroke-linecap="round" stroke-linejoin="round"/><path d="M20 13L27 20L20 27" stroke="black" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    responsive: [ 
       {
        breakpoint: 1023,
        settings: {
          slidesToShow: 5
        }
      },
      {
        breakpoint: 749,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });

  /*   $('details').on("mouseenter", function() {
        $(this).attr('open' , 'open');
    }).on("mouseleave", function() { 
        $(this).removeAttr('open' , 'open');
    });*/

//   $("details").hover(
//   function () {
//         $(this).attr('open' , 'open');
//   },
//   function () {
//         $(this).removeAttr('open' , 'open');
//   }
// );

    
 });
